export type PitchSpecification = {
  area?: string | number | null;
  playingFormat?: string | null;
  sport?: string | null;
  pitchDimensions?: {
    length?: string | number | null;
    width?: string | number | null;
    height?: string | number | null;
  } | null;
};

const hasPositiveValue = (value: unknown) => Number(value) > 0;

export const getPitchSpecificationLabel = (
  pitch: PitchSpecification,
  index: number
): string => {
  if (pitch.playingFormat) return pitch.playingFormat;
  if (hasPositiveValue(pitch.area)) return `${pitch.area} sq. ft`;

  const isCourt = ["PICKLEBALL", "BADMINTON"].includes(
    pitch.sport?.toUpperCase() || ""
  );
  return `${isCourt ? "Court" : "Pitch"} ${index + 1}`;
};

export const getPitchDimensionsLabel = (
  pitch: PitchSpecification
): string | null => {
  if (pitch.playingFormat) return null;

  const { length, width, height } = pitch.pitchDimensions || {};
  if (hasPositiveValue(pitch.area)) {
    return [length, width, height].every(hasPositiveValue)
      ? `${length} × ${width} × ${height} ft`
      : null;
  }

  return [length, width].every(hasPositiveValue)
    ? `${length} × ${width} ft`
    : null;
};

export const getPitchFullSpecificationLabel = (
  pitch: PitchSpecification,
  index: number
): string => {
  const specification = getPitchSpecificationLabel(pitch, index);
  const dimensions = getPitchDimensionsLabel(pitch);
  return dimensions ? `${specification} (${dimensions})` : specification;
};
